import { FC } from "react";
import driverContractListingByTaxiFiltersBadgeListHelper from "./driver-contract-listing-by-taxi-filters-badge-list.helper";
import DriverContractListingByTaxiFilter from "../../common/types/driver-contract-listing-by-taxi-filter";
import ListingFilterBadgeListComponent from "../../../../../../../../common/components/listing/filter/badge-list/listing-filter-badge-list.component";

type DriverContractListingByTaxiFiltersBadgeListProps = {
  filters: DriverContractListingByTaxiFilter[];
  onDeleteFilterClick: (filterIndex: number) => void;
  onDeleteAllFiltersButtonClick: () => void;
};

const DriverContractListingByTaxiFiltersBadgeListComponent: FC<
  DriverContractListingByTaxiFiltersBadgeListProps
> = (props) => {
  const badges = driverContractListingByTaxiFiltersBadgeListHelper.getBadges(
    props.filters
  );

  return (
    <ListingFilterBadgeListComponent
      badges={badges}
      onDeleteAll={props.onDeleteAllFiltersButtonClick}
      onDelete={props.onDeleteFilterClick}
    />
  );
};

export default DriverContractListingByTaxiFiltersBadgeListComponent;
